<template>
  <router-link v-if="!externalLink" :to="to" :class="size" class="link">{{ text }}</router-link>
  <a v-else :href="to" :class="size" class="link">{{ text }}</a>
</template>

<script>
export default {
  name: 'RouterButton',
  props: {
    to: {
      type: [String, Object],
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    externalLink: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  @include weight-500-barlow;
  line-height: 22px;
  text-decoration: underline;
  color: var(--primary) !important;
  &:hover {
    text-decoration: none;
  }
}
.static-link-container {
  .link {
    color: $grey-dark !important;
    text-decoration: none;
    &:hover {
      color: $grey-dark !important;
      text-decoration: underline;
    }
  }
}
</style>
